module.exports = __webpack_public_path__ + "img/club.3c6372a4.png";